import { render, staticRenderFns } from "./mobile-terminal.vue?vue&type=template&id=6fef6e24&scoped=true&"
import script from "./mobile-terminal.vue?vue&type=script&lang=js&"
export * from "./mobile-terminal.vue?vue&type=script&lang=js&"
import style0 from "./mobile-terminal.vue?vue&type=style&index=0&id=6fef6e24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fef6e24",
  null
  
)

export default component.exports